export default "__VITE_ASSET__BlsxBJtY__"